import removeUnitModalEn from "./locales/en.json";

export const REMOVE_UNIT_MODAL_NS = "removeUnitModal" as const;

export const RemoveUnitModalI18n = {
  en: {
    [REMOVE_UNIT_MODAL_NS]: {
      ...removeUnitModalEn,
    },
  },
};
